import _classCallCheck from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _Object$freeze, _Object$freeze2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/*
 * This file contains information about particular algorithm suites used
 * within the encryption SDK.  In most cases, end-users don't need to
 * manipulate this structure, but it can occasionally be needed for more
 * advanced use cases, such as writing keyrings.
 *
 * These are the WebCrypto specific values the AWS Encryption SDK for JavaScript
 * Algorithm Suites.
 */
import { AlgorithmSuite, AlgorithmSuiteIdentifier, MessageFormat } from './algorithm_suites';
import { needs } from './needs';
/* References to https://docs.aws.amazon.com/encryption-sdk/latest/developer-guide/algorithms-reference.html
 * These are the composed parameters for each algorithm suite specification for
 * for the WebCrypto environment.
 */

var webCryptoAlgAes128GcmIv12Tag16 = {
  id: AlgorithmSuiteIdentifier.ALG_AES128_GCM_IV12_TAG16,
  messageFormat: MessageFormat.V1,
  encryption: 'AES-GCM',
  keyLength: 128,
  ivLength: 12,
  tagLength: 128,
  cacheSafe: false,
  commitment: 'NONE'
};
/* Web browsers do not support 192 bit key lengths at this time. */

var webCryptoAlgAes192GcmIv12Tag16 = {
  id: AlgorithmSuiteIdentifier.ALG_AES192_GCM_IV12_TAG16,
  messageFormat: MessageFormat.V1,
  encryption: 'AES-GCM',
  keyLength: 192,
  ivLength: 12,
  tagLength: 128,
  cacheSafe: false,
  commitment: 'NONE'
};
var webCryptoAlgAes256GcmIv12Tag16 = {
  id: AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16,
  messageFormat: MessageFormat.V1,
  encryption: 'AES-GCM',
  keyLength: 256,
  ivLength: 12,
  tagLength: 128,
  cacheSafe: false,
  commitment: 'NONE'
};
var webCryptoAlgAes128GcmIv12Tag16HkdfSha256 = {
  id: AlgorithmSuiteIdentifier.ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256,
  messageFormat: MessageFormat.V1,
  encryption: 'AES-GCM',
  keyLength: 128,
  ivLength: 12,
  tagLength: 128,
  kdf: 'HKDF',
  kdfHash: 'SHA-256',
  cacheSafe: true,
  commitment: 'NONE'
};
/* Web browsers do not support 192 bit key lengths at this time. */

var webCryptoAlgAes192GcmIv12Tag16HkdfSha256 = {
  id: AlgorithmSuiteIdentifier.ALG_AES192_GCM_IV12_TAG16_HKDF_SHA256,
  messageFormat: MessageFormat.V1,
  encryption: 'AES-GCM',
  keyLength: 192,
  ivLength: 12,
  tagLength: 128,
  kdf: 'HKDF',
  kdfHash: 'SHA-256',
  cacheSafe: true,
  commitment: 'NONE'
};
var webCryptoAlgAes256GcmIv12Tag16HkdfSha256 = {
  id: AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA256,
  messageFormat: MessageFormat.V1,
  encryption: 'AES-GCM',
  keyLength: 256,
  ivLength: 12,
  tagLength: 128,
  kdf: 'HKDF',
  kdfHash: 'SHA-256',
  cacheSafe: true,
  commitment: 'NONE'
};
var webCryptoAlgAes128GcmIv12Tag16HkdfSha256EcdsaP256 = {
  id: AlgorithmSuiteIdentifier.ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256_ECDSA_P256,
  messageFormat: MessageFormat.V1,
  encryption: 'AES-GCM',
  keyLength: 128,
  ivLength: 12,
  tagLength: 128,
  kdf: 'HKDF',
  kdfHash: 'SHA-256',
  cacheSafe: true,
  signatureCurve: 'P-256',
  signatureHash: 'SHA-256',
  commitment: 'NONE'
};
/* Web browsers do not support 192 bit key lengths at this time. */

var webCryptoAlgAes192GcmIv12Tag16HkdfSha384EcdsaP384 = {
  id: AlgorithmSuiteIdentifier.ALG_AES192_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384,
  messageFormat: MessageFormat.V1,
  encryption: 'AES-GCM',
  keyLength: 192,
  ivLength: 12,
  tagLength: 128,
  kdf: 'HKDF',
  kdfHash: 'SHA-384',
  cacheSafe: true,
  signatureCurve: 'P-384',
  signatureHash: 'SHA-384',
  commitment: 'NONE'
};
var webCryptoAlgAes256GcmIv12Tag16HkdfSha384EcdsaP384 = {
  id: AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384,
  messageFormat: MessageFormat.V1,
  encryption: 'AES-GCM',
  keyLength: 256,
  ivLength: 12,
  tagLength: 128,
  kdf: 'HKDF',
  kdfHash: 'SHA-384',
  cacheSafe: true,
  signatureCurve: 'P-384',
  signatureHash: 'SHA-384',
  commitment: 'NONE'
};
var webCryptoAlgAes256GcmHkdfSha512Committing = {
  id: AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY,
  messageFormat: MessageFormat.V2,
  encryption: 'AES-GCM',
  keyLength: 256,
  ivLength: 12,
  tagLength: 128,
  kdf: 'HKDF',
  kdfHash: 'SHA-512',
  cacheSafe: true,
  commitment: 'KEY',
  commitmentHash: 'SHA-512',
  suiteDataLength: 32,
  commitmentLength: 256,
  saltLengthBytes: 32
};
var webCryptoAlgAes256GcmHkdfSha512CommittingEcdsaP384 = {
  id: AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY_ECDSA_P384,
  messageFormat: MessageFormat.V2,
  encryption: 'AES-GCM',
  keyLength: 256,
  ivLength: 12,
  tagLength: 128,
  kdf: 'HKDF',
  kdfHash: 'SHA-512',
  cacheSafe: true,
  signatureCurve: 'P-384',
  signatureHash: 'SHA-384',
  commitment: 'KEY',
  commitmentHash: 'SHA-512',
  suiteDataLength: 32,
  commitmentLength: 256,
  saltLengthBytes: 32
};
var webCryptoAlgorithms = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, AlgorithmSuiteIdentifier.ALG_AES128_GCM_IV12_TAG16, Object.freeze(webCryptoAlgAes128GcmIv12Tag16)), _defineProperty(_Object$freeze, AlgorithmSuiteIdentifier.ALG_AES192_GCM_IV12_TAG16, Object.freeze(webCryptoAlgAes192GcmIv12Tag16)), _defineProperty(_Object$freeze, AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16, Object.freeze(webCryptoAlgAes256GcmIv12Tag16)), _defineProperty(_Object$freeze, AlgorithmSuiteIdentifier.ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256, Object.freeze(webCryptoAlgAes128GcmIv12Tag16HkdfSha256)), _defineProperty(_Object$freeze, AlgorithmSuiteIdentifier.ALG_AES192_GCM_IV12_TAG16_HKDF_SHA256, Object.freeze(webCryptoAlgAes192GcmIv12Tag16HkdfSha256)), _defineProperty(_Object$freeze, AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA256, Object.freeze(webCryptoAlgAes256GcmIv12Tag16HkdfSha256)), _defineProperty(_Object$freeze, AlgorithmSuiteIdentifier.ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256_ECDSA_P256, Object.freeze(webCryptoAlgAes128GcmIv12Tag16HkdfSha256EcdsaP256)), _defineProperty(_Object$freeze, AlgorithmSuiteIdentifier.ALG_AES192_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384, Object.freeze(webCryptoAlgAes192GcmIv12Tag16HkdfSha384EcdsaP384)), _defineProperty(_Object$freeze, AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384, Object.freeze(webCryptoAlgAes256GcmIv12Tag16HkdfSha384EcdsaP384)), _defineProperty(_Object$freeze, AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY, Object.freeze(webCryptoAlgAes256GcmHkdfSha512Committing)), _defineProperty(_Object$freeze, AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY_ECDSA_P384, Object.freeze(webCryptoAlgAes256GcmHkdfSha512CommittingEcdsaP384)), _Object$freeze));
var supportedWebCryptoAlgorithms = Object.freeze((_Object$freeze2 = {}, _defineProperty(_Object$freeze2, AlgorithmSuiteIdentifier.ALG_AES128_GCM_IV12_TAG16, Object.freeze(webCryptoAlgAes128GcmIv12Tag16)), _defineProperty(_Object$freeze2, AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16, Object.freeze(webCryptoAlgAes256GcmIv12Tag16)), _defineProperty(_Object$freeze2, AlgorithmSuiteIdentifier.ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256, Object.freeze(webCryptoAlgAes128GcmIv12Tag16HkdfSha256)), _defineProperty(_Object$freeze2, AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA256, Object.freeze(webCryptoAlgAes256GcmIv12Tag16HkdfSha256)), _defineProperty(_Object$freeze2, AlgorithmSuiteIdentifier.ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256_ECDSA_P256, Object.freeze(webCryptoAlgAes128GcmIv12Tag16HkdfSha256EcdsaP256)), _defineProperty(_Object$freeze2, AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384, Object.freeze(webCryptoAlgAes256GcmIv12Tag16HkdfSha384EcdsaP384)), _defineProperty(_Object$freeze2, AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY, Object.freeze(webCryptoAlgAes256GcmHkdfSha512Committing)), _defineProperty(_Object$freeze2, AlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY_ECDSA_P384, Object.freeze(webCryptoAlgAes256GcmHkdfSha512CommittingEcdsaP384)), _Object$freeze2));
export var WebCryptoAlgorithmSuite = /*#__PURE__*/function (_AlgorithmSuite) {
  _inherits(WebCryptoAlgorithmSuite, _AlgorithmSuite);

  var _super = _createSuper(WebCryptoAlgorithmSuite);

  function WebCryptoAlgorithmSuite(id) {
    var _this;

    _classCallCheck(this, WebCryptoAlgorithmSuite);

    _this = _super.call(this, webCryptoAlgorithms[id]);
    _this.type = 'webCrypto';
    /* Precondition: Browsers do not support 192 bit keys so the AlgorithmSuiteIdentifier is removed.
     * This is primarily an error in decrypt but this make it clear.
     * The error can manifest deep in the decrypt loop making it hard to debug.
     */

    needs(Object.prototype.hasOwnProperty.call(supportedWebCryptoAlgorithms, id), '192-bit AES keys are not supported');
    Object.setPrototypeOf(_assertThisInitialized(_this), WebCryptoAlgorithmSuite.prototype);
    Object.freeze(_assertThisInitialized(_this));
    return _this;
  }

  return WebCryptoAlgorithmSuite;
}(AlgorithmSuite);
Object.freeze(WebCryptoAlgorithmSuite.prototype);
Object.freeze(WebCryptoAlgorithmSuite);